import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1170 (auth flow).
// Contract: specs/_product/field-primitive-registry.md §1 ('email').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function EmailField(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="email" inputType="email" />;
}
